<span class="snackbar-mark-light">
  {{data.huntPackagesAdded}} new Hunt Package<span
    *ngIf="data.huntPackagesAdded != 1"
    >s</span
  >
  added to Hunt Template -
  <a class="snackbar-mark" routerLink="/hunt/hunt-template/{{ data.id }}"
    >{{data.name}}</a
  ></span
>
